// src/utils/request.js
import axios from 'axios'
import { Message, MessageBox } from 'element-ui'
import store from '../store'
import { getToken } from '@/utils/auth'

// 动态计算 baseURL
const getBaseURL = () => {
  const origin = window.location.origin

  // 如果页面 URL 包含 /portal，则请求 /portal API，否则默认 /manager
  if (window.location.pathname.startsWith('/portal')) {
    return `${origin}/portal`
  } else {
    return `${origin}/manager`
  }
}

// 创建 axios 实例
const service = axios.create({
  baseURL: getBaseURL(),
  timeout: 15000 // 请求超时时间
})

// request 拦截器
service.interceptors.request.use(
  config => {
    if (store.getters.token) {
      config.headers['Authorization'] = getToken() // 每个请求带 token
    }
    return config
  },
  error => {
    console.log(error)
    return Promise.reject(error)
  }
)

// response 拦截器
service.interceptors.response.use(
  response => {
    const res = response.data
    if (res.code !== 200) {
      Message({
        message: res.message,
        type: 'error',
        duration: 3 * 1000
      })

      // 401 未登录
      if (res.code === 401) {
        MessageBox.confirm(
          '你已被登出，可以取消继续留在该页面，或者重新登录',
          '确定登出',
          {
            confirmButtonText: '重新登录',
            cancelButtonText: '取消',
            type: 'warning'
          }
        ).then(() => {
          store.dispatch('FedLogOut').then(() => {
            location.reload() // 重新实例化 vue-router
          })
        })
      }

      return Promise.reject('error')
    } else {
      return res
    }
  },
  error => {
    console.log('err' + error)
    Message({
      message: error.message,
      type: 'error',
      duration: 3 * 1000
    })
    return Promise.reject(error)
  }
)

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js